<template>
  <v-navigation-drawer
    :model-value="isMobile ? drawerOpen : true"
    @update:model-value="handleDrawerUpdate"
    app
    :permanent="!isMobile"
    :temporary="isMobile"
    :expand-on-hover="!isMobile"
    :rail="!isMobile"
    :width="isMobile ? 260 : 200"
    :style="{ backgroundColor: $vuetify.theme.themes.light.colors.primary }"
    class="d-flex flex-column"
  >
    <div class="d-flex flex-column justify-space-between fill-height">
      <!-- Main Navigation List -->
      <v-list density="compact" nav @click="closeMobileDrawer">
        <v-list-item v-if="!isSupport" prepend-icon="mdi-view-dashboard" title="Dashboard" value="dashboard" to="/dashboard" router class="nav-icon-color" active-class="custom-active" :active="activeSidebarItem === 'dashboard'"></v-list-item>
        <v-list-item prepend-icon="mdi-account-multiple" title="Models" value="models" to="/models" router class="nav-icon-color" active-class="custom-active" :active="activeSidebarItem === 'models'"></v-list-item>
        <v-list-item
          v-if="!isSupport"
          prepend-icon="mdi-finance"
          title="Sales"
          value="sales"
          to="/sales"
          router
          class="nav-icon-color"
          active-class="custom-active"
          :active="activeSidebarItem === 'sales'"
        ></v-list-item>
        <v-list-item prepend-icon="mdi-file-document-edit-outline" title="Reports" value="reports" to="/reports" router class="nav-icon-color" active-class="custom-active" :active="activeSidebarItem === 'reports'"></v-list-item>
        <v-list-item prepend-icon="mdi-calculator-variant-outline" title="Adjustments" value="adjustments" to="/adjustments" router class="nav-icon-color" active-class="custom-active" :active="activeSidebarItem === 'adjustments'"></v-list-item>
        <v-list-item v-if="!isSupport" prepend-icon="mdi-clock-outline" title="Hours" value="hours" to="/hours" router class="nav-icon-color" active-class="custom-active" :active="activeSidebarItem === 'hours'"></v-list-item>
        <v-list-item v-if="!isSupport" prepend-icon="mdi-checkbox-marked-circle-outline" title="Tasks" value="tasks" to="/tasks" router class="nav-icon-color" active-class="custom-active" :active="activeSidebarItem === 'tasks'"></v-list-item>
        <v-list-item v-if="!isSupport" prepend-icon="mdi-bank" title="Payments" value="payments" to="/payments" router class="nav-icon-color" active-class="custom-active" :active="activeSidebarItem === 'payments'"></v-list-item>
      </v-list>

      <!-- Account Button (Pinned to Bottom) -->
      <v-list density="compact" nav>
        <div class="studio-label">{{ studioLabel }}</div>
        <v-list-item
          prepend-icon="mdi-account"
          :title="userEmail"
          value="account"
          class="nav-icon-color bottom-button"
          @click="showAccountDialog = true"
        ></v-list-item>
      </v-list>
    </div>

    <!-- Account Dialog -->
    <v-dialog v-model="showAccountDialog" max-width="300">
      <v-card>
        <v-card-title class="headline">Account</v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item>
              <v-list-item-title>Email: {{ userEmail }}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Role: {{ userRole }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canAccessConfiguration" @click="goToConfiguration">
              <v-list-item-title>Configuration</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="canAccessAccountsAccess" @click="goToAccountsAccess">
              <v-list-item-title>Accounts &amp; Access</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout">
              <v-list-item-title>Log Out</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="showAccountDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

. . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . .
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;600&display=swap');
.nav-icon-color {
  color: #ffffff;
}

.custom-active {
  color: #292E1E !important;
  background-color: rgba(255, 255, 255, 0.2);
}

.bottom-button {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.studio-label {
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 600;
  font-size: 0.75rem;
  margin-bottom: 0px;
  padding-bottom: 2px;
  letter-spacing: 1px;
  font-family: 'Orbitron', sans-serif;
}
</style>

<script>
import { toast } from 'vue3-toastify';

export default {
  props: {
    modelValue: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      showAccountDialog: false,
    };
  },
  computed: {
    drawerOpen: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    isMobile() {
      return Boolean(this.$vuetify.display.smAndDown);
    },
    isSupport() {
      const user = JSON.parse(localStorage.getItem('user')) || {};
      return user.role === 'support';
    },
    userEmail() {
      const user = JSON.parse(localStorage.getItem('user')) || {};
      return user.email || 'Guest';
    },
    userRole() {
      const user = JSON.parse(localStorage.getItem('user')) || {};
      return user.role || 'Unknown';
    },
    canAccessConfiguration() {
      const user = JSON.parse(localStorage.getItem('user')) || {};
      return user.role === 'admin' || user.isAdmin === true;
    },
    canAccessAccountsAccess() {
      const user = JSON.parse(localStorage.getItem('user')) || {};
      const masterEmails = ['carolina.r@mgrouplcs.com', 'jono@mgrouplcs.com', 'jorge.n@mgrouplcs.com'];
      return user.role === 'admin'
        && masterEmails.includes(String(user.email || '').trim().toLowerCase());
    },
    isAuthenticated() {
      return !!localStorage.getItem('authToken');
    },
    activeSidebarItem() {
      const routeMap = {
        '/dashboard': 'dashboard',
        '/models': 'models',
        '/sales': 'sales',
        '/reports': 'reports',
        '/adjustments': 'adjustments',
        '/hours': 'hours',
        '/tasks': 'tasks',
        '/payments': 'payments',
      };
      const exactMatch = routeMap[this.$route.path];
      if (exactMatch) return exactMatch;
      if (this.$route.path.startsWith('/models/')) return 'models';
      return null;
    },
    studioLabel() {
      const user = JSON.parse(localStorage.getItem('user')) || {};

      // Satellite monitor is cross-studio, so show a dedicated label
      if (user.role === 'satellite_monitor') return 'SAT';

      const studioMap = {
        1: 'CC',
        2: 'CJ',
        3: 'BOG',
        4: 'PEI',
      };

      return studioMap[user.studio_id] || '';
    },
  },
  methods: {
    handleDrawerUpdate(value) {
      if (this.isMobile) this.drawerOpen = value;
    },
    closeMobileDrawer() {
      if (this.isMobile) this.drawerOpen = false;
    },
    goToConfiguration() {
      this.$router.push('/configuration');
      this.showAccountDialog = false;
    },
    goToAccountsAccess() {
      this.$router.push('/accounts-access');
      this.showAccountDialog = false;
    },
    logout() {
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      localStorage.removeItem('rememberedEmail');
      this.$router.push('/login');
      this.showAccountDialog = false;
      toast.success('Logged out successfully', { autoClose: 3000 });
    },
  },
};
</script>
